module.exports = __webpack_public_path__ + "static/waterproof-mattress-protector-1-ow-783559b35cf2513b1683b1b2c5006d97.png";